/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ResponseEntity } from '../../models/response-entity';

export interface FetchHealthUsingGet1$Params {
}

export function fetchHealthUsingGet1(http: HttpClient, rootUrl: string, params?: FetchHealthUsingGet1$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseEntity>> {
  const rb = new RequestBuilder(rootUrl, fetchHealthUsingGet1.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ResponseEntity>;
    })
  );
}

fetchHealthUsingGet1.PATH = '/v2/status';
